module.exports = __webpack_public_path__ + "static/img/ptll@2x.8c2cf37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ptll@2x.png
// module id = /bPr
// module chunks = 1